import { PreviousSearches } from './actionTypes';

export const initPreviousSearches = () => ({
    type: PreviousSearches.INIT,
});
